export default __webpack_public_path__ + "static/media/person_black_24dp 1.32d41ad1.svg";